import { z } from "zod";
import { ValidationError } from "../errors/ValidationError";
import { dispatchValidationError } from "../errors/errorDispatcher";

const notificationStateValue = z.enum(["not-read", "read", "archived", "deleted"]);

export const notificationsListRequestSchema = z.object({
  state: notificationStateValue.optional().nullable(),
  page: z.number().int().min(0).optional().default(0),
  size: z.number().int().min(1).max(200).optional().default(20),
});

export const notificationsStateRequestSchema = z.object({
  notificationIds: z.array(z.string().uuid()),
  state: notificationStateValue,
});

const notificationItemSchema = z.object({
  id: z.coerce.string(),
  title: z.string(),
  content: z.string().optional().nullable(),
  type: z.string().optional().nullable(),
  state: z.string(),
  createdAt: z.any().optional().nullable(),
});

export const notificationsListResponseSchema = z.object({
  items: z.array(notificationItemSchema),
  totalCount: z.coerce.number(),
  page: z.coerce.number().int(),
  size: z.coerce.number().int(),
});

export function validateNotificationsListRequest(data) {
  const parsed = notificationsListRequestSchema.safeParse(data ?? {});
  if (!parsed.success) {
    const message = `Invalid notifications list payload: ${parsed.error.message}`;
    dispatchValidationError({ message, issues: parsed.error.issues, raw: parsed.error });
    throw new ValidationError(message, { issues: parsed.error.issues, raw: parsed.error });
  }
  return parsed.data;
}

export function validateNotificationsStateRequest(data) {
  const parsed = notificationsStateRequestSchema.safeParse(data);
  if (!parsed.success) {
    const message = `Invalid notifications state payload: ${parsed.error.message}`;
    dispatchValidationError({ message, issues: parsed.error.issues, raw: parsed.error });
    throw new ValidationError(message, { issues: parsed.error.issues, raw: parsed.error });
  }
  return parsed.data;
}

export function parseNotificationsListResponse(data) {
  const parsed = notificationsListResponseSchema.safeParse(data);
  if (!parsed.success) {
    const message = `Unexpected notifications list response: ${parsed.error.message}`;
    dispatchValidationError({ message, issues: parsed.error.issues, raw: parsed.error });
    throw new ValidationError(message, { issues: parsed.error.issues, raw: parsed.error });
  }
  return parsed.data;
}
